import { render, staticRenderFns } from "./withPagination.vue?vue&type=template&id=05d6d510&scoped=true"
import script from "./withPagination.vue?vue&type=script&lang=js"
export * from "./withPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6d510",
  null
  
)

export default component.exports